export default {"src":"/_next/static/media/menu-icon.aa8655e9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};